import script from "./SettingsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsPanel.vue?vue&type=style&index=0&id=1167e238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1167e238"]])

export default __exports__